export default __webpack_public_path__ + "static/media/IMG_1391.2e4cda11.2e4cda11.JPG";